import Recommendations from "./Recommendations";

export default Recommendations;
